import React, { useCallback, useEffect, useState } from 'react'
import TotalUsers from './CardOptions/TotalUsers';
import TotalBusiness from './CardOptions/TotalBusiness';
import TotalAgents from './CardOptions/TotalAgents';
import TotalBookings from './CardOptions/TotalBookings';
import appUrl from '../../appUrl';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Cards = () => {
    const AppUrl = appUrl();
    const [dataLoading, setDataLoading] = useState(false)
    const [ cardAnalytics, setCardAnalytics ] = useState({ usersData: {}, totalBookings: 0, totalBusinesses: 0, totalAgents: 0 })

    const fetchCardAnalytics = useCallback( async () => {
      if(dataLoading) return;

      const token = localStorage.getItem("token");
    
      try {
        setDataLoading(true);
        
        const response = await fetch(`${AppUrl}/dashboard/analytics`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
    
        if (!data.status) {
          throw new Error(data.message || "Some error occurred!");
        }
    
        setCardAnalytics((prev) => ({
          ...prev,
          ...data.data, // Ensure the backend returns the expected format
        }));
      } catch (error) {
        console.error(error);
        toast.error(error.message || "Some error occurred!");
      } finally {
        setDataLoading(false);
      }
    }, [AppUrl]);      
  
    useEffect(() => {
      fetchCardAnalytics();
    }, [fetchCardAnalytics])


    const dashboardCardOptions = [
        { id: 1, icon: <TotalUsers />, name: 'Total Users', navUrl: '#', component: <TotalUsers usersData={cardAnalytics.usersData} dataLoading={dataLoading} /> },
        { id: 2, icon: <TotalBookings />, name: 'Total Bookings', navUrl: '/home/bookings', component: <TotalBookings totalBookings={cardAnalytics.totalBookings} dataLoading={dataLoading} /> },
        { id: 3, icon: <TotalAgents />, name: 'Total Agents', navUrl: '/home/agents', component: <TotalAgents totalAgents={cardAnalytics.totalAgents} dataLoading={dataLoading} /> },
        { id: 4, icon: <TotalBusiness />, name: 'Total Businesses', navUrl: '/home/business/approved', component: <TotalBusiness totalBusinesses={cardAnalytics.totalBusinesses} dataLoading={dataLoading} /> },
    ];

  return (
    <div className='flex-center gap-4 w-100'>
            {dashboardCardOptions ? (
                dashboardCardOptions.map((option) => {
                    return <CardLayout>{option}</CardLayout>
                })
            ) : 
            <div>No data found!</div>
        }
    </div>
  )
}

export default Cards

export const CardLayout = ({ children }) => {
  const navigate = useNavigate();
  return (
      <div className='w-25 py-2 px-3 border shadow-sm cursor-pointer' onClick={() => navigate(children.navUrl)} style={{ height: '150px', borderRadius: '25px' }}>
          {children.component}
      </div>
  )
}

